<template>
  <div class="gui-flex gui-flex-rows">
    <div class="custom-scrollbar">
      <v-flex xs12 sm4 class="pt-4 pl-2" :class="{'pl-4': $vuetify.breakpoint.smAndUp}">
        <v-btn color="blue darken-3" @click="createClick" class="ma-0 mb-4" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline>
          <v-icon class="mr-2">add</v-icon>
          Přidat spořící program
        </v-btn>
      </v-flex>
      <SporiciProgramDialog v-if="sporici_program_id!=null" :klient="id.toString()" :id="sporici_program_id.toString()" @close="sporici_program_id=null;" @changed="() => { load(); }"></SporiciProgramDialog>
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
      <v-card class="no__padding">
        <v-card-title>
          <h2>Vytvořit nový program</h2>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <v-form ref="createForm" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex d-flex>
                <meny v-model="newItem.mena_id" @changed="(e) => { newItem.mena = e; if (typeof $refs.sporiciproduktsearch != 'undefined') { $refs.sporiciproduktsearch.clearItem(); } clearNewItem(); }"></meny>
              </v-flex>
            </v-layout>
            <v-layout row flex>
              <div class="pt-2 pb-2 pr-2 mx-2">
                Datum sjednání:
              </div>
            </v-layout>
            <v-layout row wrap>
              <v-flex d-flex>
                <datetimepicker v-model="newItem.datum_sjednani" class="mx-2"></datetimepicker>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-2" v-if="newItem.mena_id != null">
              <v-flex xs12>
                <sporiciproduktsearch label="Vyhledat produkt" v-model="newItem.sporici_produkt_id" @changed="newItemSporiciProduktChanged" class="mx-2" :mena="newItem.mena_id" ref="sporiciproduktsearch"></sporiciproduktsearch>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.sporici_produkt_id != null && newItem.mena_id != null" class="mt-3">
              <v-flex xs12>
                <v-flex xs12 sm12>
                  <v-text-field label="Název spoření" v-model="newItem.nazev_sporeni" class="mx-2"></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.sporici_produkt_id != null && newItem.mena_id != null" class="mt-3">
              <v-flex xs12 sm12 row>
                <div class="mx-2">
                  <p class="mb-0">Způsob platby vstupního poplatku:</p>
                  <v-radio-group v-model="newItem.typ_vstupni_poplatek" row class="mt-1" @change="typVstupniPoplatekChanged">
                    <v-radio label="Na začátku" value="na_zacatku"></v-radio>
                    <v-radio label="Během spoření" value="ve_sporeni"></v-radio>
                  </v-radio-group>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.sporici_produkt_id != null && newItem.mena_id != null">
              <v-flex xs12 sm4 class="pt-2">
                <v-text-field :label="newItem.typ_vstupni_poplatek=='ve_sporeni' ? 'Vstupní poplatek (1 %)' : 'Vstupní poplatek'" v-model="newItem.vstupni_poplatek" type="number" class="mx-2" :suffix="newItem.mena.zkratka" @input="() => { newItem.prvni_platba = parseFloat(newItem.vstupni_poplatek) + parseFloat(newItem.mesicni_platba) }"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pt-2">
                <v-text-field label="Vstupní poplatek (% během spoření)" v-if="newItem.typ_vstupni_poplatek=='ve_sporeni'" v-model="newItem.vstupni_poplatek_procento" type="number" class="mx-2" suffix="%" @input="poplatekBehemSporeni"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="pt-2">
                <v-text-field label="Vstupní poplatek (během spoření)" v-if="newItem.typ_vstupni_poplatek=='ve_sporeni'" v-model="newItem.behem_sporeni" type="number" class="mx-2" :suffix="newItem.mena.zkratka" disabled></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.sporici_produkt_id != null && newItem.mena_id != null" class="mt-3">
              <v-flex xs12 sm4>
                <v-text-field label="Cílová částka" v-model="newItem.cilova_castka" class="mx-2" :suffix="newItem.mena.zkratka"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Měsíční platba" v-model="newItem.mesicni_platba" class="mx-2" :suffix="newItem.mena.zkratka" @input="() => { newItem.prvni_platba = parseFloat(newItem.vstupni_poplatek) + parseFloat(newItem.mesicni_platba) }"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="První platba" v-model="newItem.prvni_platba" type="number" class="mx-2" :suffix="newItem.mena.zkratka" suffix="%" disabled></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-2" v-if="newItem.sporici_produkt_id != null">
              <v-flex xs12>
                <sporicicilovyproduktsearch label="Vyberte cílový produkt" v-model="newItem.cilovy_produkt_id" :id="newItem.sporici_produkt_id" class="mx-2" :mena="newItem.mena_id"></sporicicilovyproduktsearch>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
          <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>

      <!-- TODO SporiciProgramDialog -->

      <div class="table-border__radius pb-4 pr-0 pl-2" :class="{'pl-4 pr-4': $vuetify.breakpoint.smAndUp}">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loadingTable"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.datum_sjednani | formatDate }}</td>
            <td>{{ props.item.nazev_sporeni }}</td>
            <td><router-link :to="{ path: '/sporici-produkty/'+props.item.sporici_produkt.id }" target="_blank">{{ props.item.sporici_produkt.sporici_program }}</router-link></td>
            <td>{{ props.item.variabilni_symbol }}</td>
            <td>{{ props.item.cilova_castka | formatMoney }} Kč</td>
            <td>{{ props.item.mesicni_platba | formatMoney }} Kč</td>
            <td>{{ props.item.prvni_platba | formatMoney }} Kč</td>
            <td><span v-if="props.item.stav_sporeni=='probiha'">Probíhá</span><span v-else-if="props.item.stav_sporeni=='zruseno'">Zrušeno</span><span v-else>Dokončeno</span></td>
            <td class="text-center">
              <v-btn color="primary" @click.prevent="sporiciProgramDetail(sporici_program_id=props.item.id)" class="elevation-0">Detail</v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import Platby from '@/pages/Klienti/Platby'
import PredaneProdukty from '@/pages/Klienti/PredaneProdukty'
import SporiciProgramDialog from './/SporiciProgramDialog'
export default {
  data () {
    return {
      loading: false,
      //Table start
      headers: [
        { text: 'Datum sjednání', value: 'datum_sjednani' },
        { text: 'Název spoření', value: 'nazev_sporeni' },
        { text: 'Spořící program', value: 'sporici_produkt_id' },
        { text: 'VS', value: 'variabilni_symbol' },
        { text: 'Cílová částka', value: 'cilova_castka' },
        { text: 'Měsíční platba', value: 'mesicni_platba' },
        { text: 'První platba', value: 'prvni_platba' },
        { text: 'Stav', value: 'sporici_program_stav' },
        { text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      items: [],
      //Table end
      activeTab: 0,
      tabs: [ 'platby', 'rocni_bonusy', 'graf_sporeni', 'predane_produkty' ],
      item: {},
      editMode: false,
      dialogCreate: false,
      dialogDetail: false,
      updateItem: {},
      updating: false,
      sending: false,
      valid: true,
      dialogInit: {
        nazev_sporeni: null,
        cilova_castka: null,
        mesicni_platba: null,
        prvni_platba: null,
        datum_sjednani: null,
        mena: null,
        mena_id: 1,
        cilovy_produkt_id: null,
        typ_vstupni_poplatek: "na_zacatku",
        vstupni_poplatek_procento: 0,
        vstupni_poplatek: 0,
        behem_sporeni: 0
      },
      newItem: null,
      // Dialog create end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      sporici_program_id: null
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
    if (typeof this.$props.sporici_program != "undefined" && this.$props.sporici_program != null)
      this.sporici_program_id = this.$props.sporici_program;
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
  			this.load();
  		},
  		deep: true
  	},
  },
  props: {
    id: String,
    sporici_program: String
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("osoby/"+this.$props.id+"/sporici-programy/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.newItem.datum_sjednani = parseInt(new Date().getTime() / 1000);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("osoby/" + this.$props.id + "/sporici-programy", this.newItem).then(function(body) {
          if (body.inserted) {
            this.load();
            this.dialogCreate = false;
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    newItemSporiciProduktChanged (e) {
      this.newItem.nazev_sporeni = e.sporici_program.toString();
      this.newItem.cilova_castka = e.min_cilova_castka.toString();
      this.newItem.vstupni_poplatek = parseInt(parseFloat(e.vstupni_poplatek)/100.0*e.min_cilova_castka).toString();
      this.newItem.mesicni_platba = e.min_mesicni_splatka.toString();
      this.newItem.prvni_platba = parseFloat(this.newItem.vstupni_poplatek) + parseFloat(this.newItem.mesicni_platba);
      this.newItem.vstupni_poplatek_procento = parseFloat(e.vstupni_poplatek);
    },
    clearNewItem () {
      this.newItem.nazev_sporeni = null;
      this.newItem.cilova_castka = null;
      this.newItem.prvni_platba = null;
      this.newItem.mesicni_platba = null;
    },
    typVstupniPoplatekChanged () {

      if (this.newItem.typ_vstupni_poplatek == 've_sporeni')  {
        this.newItem.vstupni_poplatek=parseFloat(this.newItem.cilova_castka)/100;
        this.newItem.behem_sporeni=parseFloat(this.newItem.cilova_castka) * parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0;
      }

      if (this.newItem.typ_vstupni_poplatek == 'na_zacatku') {
        this.newItem.vstupni_poplatek = parseInt(parseFloat(this.newItem.vstupni_poplatek_procento)/100.0*this.newItem.cilova_castka);
      }

      this.newItem.prvni_platba = parseFloat(this.newItem.vstupni_poplatek) + parseFloat(this.newItem.mesicni_platba);

    },
    poplatekBehemSporeni () {

      if (this.newItem.mena_id == 1)
        this.newItem.behem_sporeni = parseInt((parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0 * parseFloat(this.newItem.cilova_castka)));
      else
        this.newItem.behem_sporeni = (parseFloat(this.newItem.vstupni_poplatek_procento) / 100.0 * parseFloat(this.newItem.cilova_castka)).toFixed(2);

    },
    sporiciProgramDetail(id) {
      window.api.put('osoby/' + this.$props.id + '/sporici-programy/' + this.$props.sporici_program)
        .then(() => {
          this.$router.push({path: '/klienti/' + this.$props.id + '/sporici-programy/' + id})
        })
    }


  },
  components: {
    RocniBonusy, Platby, PredaneProdukty, SporiciProgramDialog
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/SporiciProgramy.vue